import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';

export class PageGroupItemMoveConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, current, incoming } = conflict;

		const incomingParent = incoming as any;
		const currentParent = current as any;

		state.initialCourse.chapters.entities[incomingParent.family_id].page_groups =
			incomingParent.page_groups;
		state.chapters.entities[incomingParent.family_id].page_groups = incomingParent.page_groups;

		state.initialCourse.chapters.entities[currentParent.family_id].page_groups =
			currentParent.page_groups.filter((id) => id !== entityId);
		state.chapters.entities[currentParent.family_id].page_groups = currentParent.page_groups.filter(
			(id) => id !== entityId
		);
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
